module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-teatopics-intro-card1.2.b2d33f6b.jpg";